var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 176,
    height: 32,
    viewBox: "0 0 176 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_355992",
    "data-name": "\\uC0AC\\uAC01\\uD615 355992",
    width: 176,
    height: 32,
    transform: "translate(-10773 11998)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB9C8\\uC2A4\\uD06C_\\uADF8\\uB8F9_7482",
    "data-name": "\\uB9C8\\uC2A4\\uD06C \\uADF8\\uB8F9 7482",
    transform: "translate(10773 -11998)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-10773.097 11997.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862730",
    "data-name": "\\uD328\\uC2A4 862730",
    d: "M28.212,18.24,30.955,3.594,2.779,27.964H40.6L45.163,3.594Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862731",
    "data-name": "\\uD328\\uC2A4 862731",
    d: "M45.163,3.592,40.6,27.962H2.779L30.955,3.592,28.212,18.237ZM32.465.965,30.3,2.837,2.124,27.208.1,28.961H41.434l.153-.815L46.146,3.775,46.672.969,44.508,2.837,29.721,15.613,31.938,3.775l.526-2.81Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862732",
    "data-name": "\\uD328\\uC2A4 862732",
    d: "M2.779,27.943H26.4L30.955,3.582Z",
    fill: "#001f60"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862733",
    "data-name": "\\uD328\\uC2A4 862733",
    d: "M28.213,18.237s-.5-3.165-.483-3.995c.011-.7.2-5.942.281-8.117l-.7.607c-.049,2.047-.167,6.868-.208,7.478-.027.4-.735,3.918-.735,3.918a32.529,32.529,0,0,1-1.481-3.787c-.122-.671-.476-3.47-.66-4.944l-.613.53c.225,1.475.616,4.047.666,4.512.066.609-.131,4.049-.131,4.049s-1.88-2.922-2.088-3.441c-.176-.441-.684-2.017-.977-2.932l-.485.419c.273.836.764,2.341.885,2.739.127.42.725,3.989.725,3.989s-2.3-2.26-2.771-2.921c-.25-.349-.823-1.241-1.173-1.789l-.487.421c.343.505.913,1.352,1.125,1.725.235.412,1.518,3.779,1.518,3.779s-3.107-2.109-3.313-2.275c-.246-.2-.962-.957-1.406-1.434l-.5.429c.462.48,1.223,1.275,1.43,1.5.259.28,2.337,3.317,2.337,3.317s-3.291-1.244-3.717-1.527l-2.18-1.446-.506.437c.652.431,1.951,1.292,2.345,1.563.533.368,2.958,2.81,2.958,2.81L13.9,23.185c-.626-.2-3-1.033-4.019-1.387l-.576.5c1.063.367,3.672,1.27,4.376,1.534.448.168,3.524,2.015,3.524,2.015s-3.419.066-3.991.051c-.5-.012-5.7-.755-6.986-.939L5.5,25.59c1.57.184,6.7.787,7.634.929a35.7,35.7,0,0,1,3.853,1.425l11.221-9.688Z",
    fill: "#ffcc05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862734",
    "data-name": "\\uD328\\uC2A4 862734",
    d: "M16.986,27.943H40.6L45.162,3.582Z",
    fill: "#ee2a29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862735",
    "data-name": "\\uD328\\uC2A4 862735",
    d: "M51.379,23.571H48.792l-.818,4.379H45.445l2.289-12.168H53.04a3.661,3.661,0,0,1,2.747.941,3.173,3.173,0,0,1,.546,2.913,4.588,4.588,0,0,1-1.669,3.045A5.564,5.564,0,0,1,51.379,23.571Zm.853-5.669H49.861l-.673,3.58H51.56a2.412,2.412,0,0,0,1.485-.437,2.128,2.128,0,0,0,.76-1.386,1.412,1.412,0,0,0-.244-1.352A1.884,1.884,0,0,0,52.232,17.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862736",
    "data-name": "\\uD328\\uC2A4 862736",
    d: "M64.754,19.9a1.99,1.99,0,0,1,.261,1.035,12.84,12.84,0,0,1-.243,1.736l-.995,5.277H61.371l1.023-5.469a2.279,2.279,0,0,0-.02-1.172q-.206-.627-1.106-.627a2.038,2.038,0,0,0-1.534.623,3.42,3.42,0,0,0-.82,1.777L58,27.95H55.652l2.282-12.122h2.347l-.812,4.3a3.6,3.6,0,0,1,2.867-1.4,3.466,3.466,0,0,1,1.462.289A2.034,2.034,0,0,1,64.754,19.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862737",
    "data-name": "\\uD328\\uC2A4 862737",
    d: "M66.847,18.964h2.388l-1.689,8.988H65.158Zm2.593-1.091H67.052l.41-2.166H69.85Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862738",
    "data-name": "\\uD328\\uC2A4 862738",
    d: "M71.384,27.949H69.029l2.289-12.168h2.355Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862739",
    "data-name": "\\uD328\\uC2A4 862739",
    d: "M74.557,18.964h2.388l-1.689,8.988H72.867Zm2.593-1.091H74.761l.41-2.166H77.56Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862740",
    "data-name": "\\uD328\\uC2A4 862740",
    d: "M86.188,23.341a6.521,6.521,0,0,1-1.751,3.623,4.2,4.2,0,0,1-2.99,1.246,2.461,2.461,0,0,1-1.683-.535,2.546,2.546,0,0,1-.6-.864l-.886,4.671H75.949l2.363-12.521h2.256l-.248,1.33a4.957,4.957,0,0,1,.986-.926,3.456,3.456,0,0,1,1.977-.6,2.9,2.9,0,0,1,2.454,1.163A4.261,4.261,0,0,1,86.188,23.341ZM82.217,20.82a2.195,2.195,0,0,0-1.987,1.214,5.392,5.392,0,0,0-.555,1.634,2.267,2.267,0,0,0,.418,2.2,1.636,1.636,0,0,0,1.108.371,2.088,2.088,0,0,0,1.643-.759,4.173,4.173,0,0,0,.893-2.023,3.222,3.222,0,0,0-.128-1.841A1.339,1.339,0,0,0,82.217,20.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862741",
    "data-name": "\\uD328\\uC2A4 862741",
    d: "M95.677,23.341a6.522,6.522,0,0,1-1.75,3.623,4.2,4.2,0,0,1-2.99,1.246,2.462,2.462,0,0,1-1.683-.535,2.547,2.547,0,0,1-.6-.864l-.886,4.671h-2.33L87.8,18.961h2.256l-.248,1.33a4.957,4.957,0,0,1,.986-.926,3.456,3.456,0,0,1,1.977-.6,2.9,2.9,0,0,1,2.454,1.163A4.261,4.261,0,0,1,95.677,23.341ZM91.706,20.82a2.2,2.2,0,0,0-1.987,1.214,5.406,5.406,0,0,0-.555,1.634,2.266,2.266,0,0,0,.418,2.2,1.635,1.635,0,0,0,1.108.371,2.087,2.087,0,0,0,1.643-.759,4.175,4.175,0,0,0,.892-2.023,3.224,3.224,0,0,0-.128-1.841A1.339,1.339,0,0,0,91.706,20.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862742",
    "data-name": "\\uD328\\uC2A4 862742",
    d: "M97.39,18.964h2.388l-1.689,8.988H95.7Zm2.593-1.091H97.594L98,15.707h2.388Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862743",
    "data-name": "\\uD328\\uC2A4 862743",
    d: "M108.828,21.9l-1.141,6.053h-2.414L106.3,22.48a2.25,2.25,0,0,0,.014-1.089q-.214-.693-1.19-.693a2.04,2.04,0,0,0-1.835,1.014,3.92,3.92,0,0,0-.487,1.369l-.914,4.867H99.538l1.689-8.972H103.5l-.249,1.309a5.3,5.3,0,0,1,1.05-1,3.475,3.475,0,0,1,1.946-.543,2.951,2.951,0,0,1,2.146.73A2.585,2.585,0,0,1,108.828,21.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862744",
    "data-name": "\\uD328\\uC2A4 862744",
    d: "M117.48,20.469a3.839,3.839,0,0,1,.335,1.858,11.323,11.323,0,0,1-.254,1.784H111.4A1.872,1.872,0,0,0,111.888,26a1.719,1.719,0,0,0,1.108.337,2.009,2.009,0,0,0,1.262-.412,2.767,2.767,0,0,0,.556-.618h2.4a3.845,3.845,0,0,1-1.142,1.624,4.925,4.925,0,0,1-3.489,1.311,3.827,3.827,0,0,1-2.825-1.1q-1.105-1.105-.637-3.6a6.071,6.071,0,0,1,1.858-3.58,4.867,4.867,0,0,1,3.313-1.245,4.232,4.232,0,0,1,1.948.421A2.668,2.668,0,0,1,117.48,20.469Zm-5.734,2.089h3.661a1.753,1.753,0,0,0-.3-1.42,1.47,1.47,0,0,0-1.173-.484,1.91,1.91,0,0,0-1.363.514,3.19,3.19,0,0,0-.822,1.391Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862745",
    "data-name": "\\uD328\\uC2A4 862745",
    d: "M126.776,15.781h2.876l2.025,12.168h-2.76l-.318-2.5h-4.487l-1.311,2.5H120.14Zm-1.583,7.574h3.091l-.622-4.786Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862746",
    "data-name": "\\uD328\\uC2A4 862746",
    d: "M133.9,18.964h2.388L134.6,27.952h-2.389Zm2.593-1.091h-2.388l.409-2.166h2.389Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862747",
    "data-name": "\\uD328\\uC2A4 862747",
    d: "M142.969,18.765l-.454,2.412c-.144-.016-.273-.027-.389-.033s-.21-.008-.281-.008a2.392,2.392,0,0,0-2.085.923,4.186,4.186,0,0,0-.573,1.6l-.8,4.294h-2.372l1.689-8.988h2.248l-.292,1.568a6.649,6.649,0,0,1,1.177-1.23,3.056,3.056,0,0,1,1.829-.553c.044,0,.082,0,.112,0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862748",
    "data-name": "\\uD328\\uC2A4 862748",
    d: "M144.18,27.949h-2.356l2.289-12.168h2.356Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862749",
    "data-name": "\\uD328\\uC2A4 862749",
    d: "M147.351,18.964h2.389l-1.689,8.988h-2.389Zm2.594-1.091h-2.389l.41-2.166h2.388Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862750",
    "data-name": "\\uD328\\uC2A4 862750",
    d: "M158.791,21.9l-1.142,6.053h-2.413l1.023-5.469a2.253,2.253,0,0,0,.015-1.089q-.216-.693-1.19-.693a2.04,2.04,0,0,0-1.835,1.014,3.92,3.92,0,0,0-.487,1.369l-.914,4.867H149.5l1.69-8.972h2.273l-.249,1.309a5.244,5.244,0,0,1,1.05-1,3.472,3.472,0,0,1,1.945-.543,2.95,2.95,0,0,1,2.146.73A2.585,2.585,0,0,1,158.791,21.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862751",
    "data-name": "\\uD328\\uC2A4 862751",
    d: "M167.443,20.469a3.839,3.839,0,0,1,.335,1.858,11.444,11.444,0,0,1-.254,1.784h-6.166A1.875,1.875,0,0,0,161.851,26a1.717,1.717,0,0,0,1.108.337,2.006,2.006,0,0,0,1.261-.412,2.743,2.743,0,0,0,.556-.618h2.4a3.845,3.845,0,0,1-1.142,1.624,4.925,4.925,0,0,1-3.489,1.311,3.827,3.827,0,0,1-2.825-1.1q-1.105-1.105-.638-3.6a6.077,6.077,0,0,1,1.859-3.58,4.867,4.867,0,0,1,3.313-1.245,4.232,4.232,0,0,1,1.948.421A2.674,2.674,0,0,1,167.443,20.469Zm-5.734,2.089h3.662a1.756,1.756,0,0,0-.3-1.42,1.473,1.473,0,0,0-1.173-.485,1.912,1.912,0,0,0-1.364.514,3.19,3.19,0,0,0-.822,1.392Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_862752",
    "data-name": "\\uD328\\uC2A4 862752",
    d: "M169.9,25.079a1.347,1.347,0,0,0,.162.895q.342.473,1.525.472a2.753,2.753,0,0,0,1.143-.206.849.849,0,0,0,.53-.619.553.553,0,0,0-.221-.6,11.57,11.57,0,0,0-2.323-.71,4.1,4.1,0,0,1-1.974-.949,1.756,1.756,0,0,1-.321-1.618,3.507,3.507,0,0,1,1.382-2.142,4.612,4.612,0,0,1,2.924-.9,4.424,4.424,0,0,1,2.62.673,2.386,2.386,0,0,1,.784,2.323H173.78a1.248,1.248,0,0,0-.125-.719,1.355,1.355,0,0,0-1.235-.479,2.136,2.136,0,0,0-1.139.239.87.87,0,0,0-.428.561.5.5,0,0,0,.237.586,12.9,12.9,0,0,0,2.331.652,3.623,3.623,0,0,1,1.917,1,1.947,1.947,0,0,1,.38,1.692,3.44,3.44,0,0,1-1.41,2.183,5.376,5.376,0,0,1-3.235.846,3.983,3.983,0,0,1-2.969-.9,2.487,2.487,0,0,1-.589-2.284Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHLogo);
export default __webpack_public_path__ + "static/media/h-logo.3956654aa933ec2c450239822f8cef38.svg";
export { ForwardRef as ReactComponent };